<template>
    <product v-if="'filler' in item && item.filler === true"></product>
    <product
        v-else-if="item.type === 'product'"
        :product-id="item.productId"
        v-model:product-name="item.productName"
        :overlay-text="item.overlayText ?? undefined"
        :overlay-text-type="item.overlayTextType ?? undefined"
        :third-party-stamp="item.thirdPartyStamp"
        :related-auction-stamp="item.relatedAuctionStamp"
        :related-shop-stamp="item.relatedShopStamp"
        :index-of-list="indexOfList"
        :scale-of-screen="scaleOfScreen"
        :page="item.page"
        :image-info="item"
        :is-auction="item.isAuction"
        :is-shop="item.isShop"
        :is-buynow="item.isBuyNow"
        v-model:product-value="item.value"
        :registration="registration"
        v-model:price="item.price"
        :link="item.link"
        v-model:seconds-left="item.timeTotalSeconds"
        v-model:time-is-not-started="item.timeIsNotStarted"
        :price-comparison-enabled="false"
        v-model:has-bid="item.hasBid"
        :overwrite-settings="overwriteSettings"
        :tracking-info="item.trackingInfo ?? undefined"
        @input="$emit('input', $event)"
        :mobile="mobile"
    ></product>
    <advert
        v-else-if="item.type === 'advert'"
        :item="item"
        @input="$emit('input', $event)"
        :scale-of-screen="scaleOfScreen"
        :mobile="mobile"
    ></advert>
    <product-gallery v-else-if="item.type === 'gallery'" :item="item">
    </product-gallery>
    <li v-else data-error="unknown type"></li>
</template>

<script lang="ts">
export default {
    model: {
        prop: "item",
    },
};
</script>

<script setup lang="ts">
import product from "./product.vue";
import {
    type PropType,
    getCurrentInstance,
    onBeforeUnmount,
    onMounted,
} from "vue";
import {
    type ProductGalleryItem,
    type AdvertItem,
    type FillerItem,
    type ProductListItem,
} from "../../list-item";
import type { ListController } from "../../list-controller";
import { type OverwriteSettings } from "../../../../../commons/product/overwrite-settings";
import ProductGallery from "../common/product-gallery.vue";
import advert from "./advert.vue";
import { type ProductRegistrationResult } from "../common/product-updater";
import { createItemObservator } from "../common/item-observation";

// const advert = defineAsyncComponent(
//     () =>
//         import(
//             /* webpackFetchPriority: "high" */
//             "./advert.vue"
//         )
// );

const props = defineProps({
    item: {
        type: Object as PropType<
            | ProductListItem
            | AdvertItem
            | ProductGalleryItem
            | { type: never; filler: true }
            | FillerItem
        >,
        required: true,
    },
    indexOfList: Number,
    mobile: Boolean,
    listController: {
        type: Object as PropType<ListController>,
    },
    isLast: Boolean,
    isFirstOfPage: Boolean,
    overwriteSettings: Object as PropType<OverwriteSettings>,
    scaleOfScreen: {
        type: Number,
        default: 1,
    },
    registration: Object as PropType<ProductRegistrationResult>,
});

const instance = getCurrentInstance();
const itemObservator = createItemObservator(
    instance,
    () => props.isLast,
    () => props.item,
    () => props.listController,
    () => props.isFirstOfPage
);

onMounted(() => {
    itemObservator?.start(props);
});

onBeforeUnmount(() => {
    itemObservator?.stop();
});
</script>
